import TrailingReturnsChart from "components/charts/modern/TrailingReturnsChart";
import useBrazilianRealEstateFundIssuer from "components/company/v3/context/hooks/useBrazilianRealEstateFundIssuer";
import SadFaceIcon from "components/icons/SadFaceIcon";
import { FormattedMessage } from "react-intl";

export default function FiisHistoricalReturnContent() {
  const issuer = useBrazilianRealEstateFundIssuer();

  if (!issuer.trailingReturns) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <div className="space-y-2 text-center text-base tracking-wide text-gray-600">
          <div>
            <SadFaceIcon />
          </div>

          <p>
            <FormattedMessage defaultMessage="Nenhum dado foi encontrado." id="i1Elih" />
          </p>
        </div>
      </div>
    );
  }

  return <TrailingReturnsChart tickerSymbols={[issuer.tickerSymbol]} />;
}
